import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPlugin1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="plugin-1, power, adapter"><path d="M9.5 2.75C9.5 2.33579 9.16421 2 8.75 2C8.33579 2 8 2.33579 8 2.75V5.5H4.75C4.33579 5.5 4 5.83579 4 6.25V14.25C4 16.8734 6.12665 19 8.75 19H11.25V21.25C11.25 21.6642 11.5858 22 12 22C12.4142 22 12.75 21.6642 12.75 21.25V19H15.25C17.8734 19 20 16.8734 20 14.25V6.25C20 5.83579 19.6642 5.5 19.25 5.5H16V2.75C16 2.33579 15.6642 2 15.25 2C14.8358 2 14.5 2.33579 14.5 2.75V5.5H9.5V2.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconPlugin1;
